import {ApiService} from './api/api.service';
import {Injectable} from '@angular/core';
import {AppScope} from './app_scope.service';
import {Observable} from "rxjs";
import {SessionState} from "../_models/session-state";
import {SearchQueryOptions} from "./api/search-query-options";
import {HttpClient} from "@angular/common/http";
import {NotificationService} from "./notification.service";

@Injectable({
    providedIn: 'root'
})
export class UserDataService {
    report;
    dashboards = [];

    constructor(private appScope: AppScope,
                private api: ApiService,
                private http: HttpClient,
                private notification: NotificationService) {
    }

    checkSuperUser(user) {
        return user.role_names.indexOf('Super_User') > -1;
    }

    get current_user(): any {
        return this.appScope.current_user;
    }

    getRestrictedDashboards(user?): Observable<any> {
        let restricted_list;
        if (user) {
            restricted_list = user.relationships.dashboards.data.map(d => d.id);
        } else {
            restricted_list = this.appScope.current_user.dashboards;
        }

        const query = new SearchQueryOptions();
        query.filters = [
            {'op': 'in', 'name': 'id', val: restricted_list}
        ];

        return this.api.session_state_light.searchMany(query);
    }

    /**
     * Get the list of restricted dashboard ids for the current or given user.
     * @param session_states
     * @param user
     */
    getRestrictedDashboardsQuick(session_states: SessionState[], user?): SessionState[] {
        let restricted_list;
        if (user) {
            restricted_list = user.relationships.dashboards.data.map(d => d.id);
        } else {
            restricted_list = this.appScope.current_user.dashboards;
        }

        return session_states.filter(state => !!restricted_list.find(item => item === state.id));
    }
}
